import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsSection = () => {
  const benefits = [
    {
      icon: 'ChefHat',
      title: 'Authentic Home Cooking',
      description: 'Access delicious homemade meals from verified local chefs'
    },
    {
      icon: 'MessageSquare',
      title: 'Direct Communication',
      description: 'Chat with chefs for custom orders and special requests'
    },
    {
      icon: 'Star',
      title: 'Quality Assured',
      description: 'Food safety certified suppliers with customer reviews'
    },
    {
      icon: 'Truck',
      title: 'Flexible Delivery',
      description: 'Choose delivery or pickup based on your convenience'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
      {benefits?.map((benefit, index) => (
        <div 
          key={index}
          className="flex gap-4 p-4 md:p-5 bg-card rounded-xl shadow-warm-sm hover:shadow-warm transition-smooth"
        >
          <div 
            className="w-12 h-12 md:w-14 md:h-14 flex-shrink-0 rounded-xl flex items-center justify-center"
            style={{ backgroundColor: 'var(--color-primary)15' }}
          >
            <Icon 
              name={benefit?.icon} 
              size={24} 
              color="var(--color-primary)"
            />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-semibold text-base md:text-lg mb-1">
              {benefit?.title}
            </h3>
            <p className="text-sm md:text-base text-muted-foreground line-clamp-2">
              {benefit?.description}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BenefitsSection;